import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function MediaQueryXl(props) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only('xl'));
  if(matches) {
    return props.content
  } else {
    return null
  }
}

export default MediaQueryXl;